var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 61,
    viewBox: "0 0 47 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2338 1.37018H6.76618C3.80139 1.37018 1.39795 3.72581 1.39795 6.63163V54.3684C1.39795 57.2742 3.80139 59.6298 6.76618 59.6298H40.2338C43.1986 59.6298 45.602 57.2742 45.602 54.3684V6.63163C45.602 3.72581 43.1986 1.37018 40.2338 1.37018Z",
    stroke: "#0A7CC1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6781 1.37018V7.82368C31.6781 8.7965 30.8673 9.5912 29.8747 9.5912H16.8595C15.867 9.5912 15.0562 8.7965 15.0562 7.82368V1.37018H31.6641H31.6781Z",
    stroke: "#0A7CC1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9874 6.89197H15.0704V7.82368C15.0704 8.7965 15.8812 9.5912 16.8738 9.5912H29.889C30.8815 9.5912 31.6924 8.7965 31.6924 7.82368V6.89197H33.7754C35.3551 6.89197 36.6552 8.16623 36.6552 9.71452V12.2904C36.6552 13.8387 35.3551 15.113 33.7754 15.113H13.0014C11.4217 15.113 10.1216 13.8387 10.1216 12.2904V9.71452C10.1216 8.16623 11.4217 6.89197 13.0014 6.89197H12.9874Z",
    stroke: "#0A7CC1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2067 31.1029H27.0928",
    stroke: "#0A7CC1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2067 36.8028H27.0928",
    stroke: "#0A7CC1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2067 42.5027H27.0928",
    stroke: "#0A7CC1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8188 22.3201L17.2932 23.7176L19.7816 25.1289V27.9378V30.7466L17.2932 32.1442L14.8188 33.5418L12.3444 32.1442L9.85596 30.7466V27.9378V25.1289L12.3444 23.7176L14.8188 22.3201Z",
    stroke: "#0A7CC1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8188 38.0359L17.2932 39.4472L19.7816 40.8448V43.6536V46.4625L17.2932 47.8601L14.8188 49.2713L12.3444 47.8601L9.85596 46.4625V43.6536V40.8448L12.3444 39.4472L14.8188 38.0359Z",
    stroke: "#0A7CC1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8184 33.5418V38.0359",
    stroke: "#0A7CC1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 61,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescription);
export default __webpack_public_path__ + "static/media/prescription.20f9489c8dc4bdd2926b3e9e1dadb6b4.svg";
export { ForwardRef as ReactComponent };